import en from '../../public/locales/en/common.json'
import { convertLanguageJsonToObject } from './translations'

// Create the 'translations' object to provide full intellisense support for the static json files.
convertLanguageJsonToObject(en)
